import React, { Component } from 'react'

import SortableTable from './SortableTable'

import { formatNumber } from '../../formatter'

import { Link } from 'react-router-dom'

class PowerProjectTable extends Component {
  render () {
    let columns = [
      { id: 'renewableType',
        name: 'Power',
        accessor: d => d.renewableType,
        displayAccessor: d => <span><i className={d.icon} />&nbsp;{d.renewableTypeShortName}</span>,
        filterable: true,
        headerClass: 'narrow'
      },
      { id: 'renewableMW',
        name: 'MW',
        accessor: d => d.renewableMW,
        displayAccessor: d => formatNumber(d.renewableMW),
        headerClass: 'narrow text-right',
        cellClass: 'text-right',
        sortDescFirst: true
      },
      { id: 'name',
        name: 'Project',
        accessor: d => d.name,
        displayAccessor: d => <Link to={d.URL()}>{d.name}</Link>,
        filterable: true
      },
      { id: 'owner',
        name: 'Owner',
        accessor: d => d.owner,
        filterable: true
        // headerClass: 'medium'
      },
      { id: 'operator',
        name: 'Operator',
        accessor: d => d.operator,
        filterable: true
        // headerClass: 'medium'
      },
      { id: 'city',
        name: 'City',
        accessor: d => d.city,
        filterable: true
        // headerClass: 'medium'
      }
    ]

    if (!this.props.simpleListing) {
      columns = columns.concat([
        { id: 'province',
          name: 'Province',
          accessor: d => [d.province, d.provinceCode],
          displayAccessor: d => d.jurisdiction,
          filterable: true,
          headerClass: 'narrow',
          onlyFilterFromStart: true
        },
        { id: 'provincialRiding',
          name: 'Provincial Riding',
          accessor: d => d.provincialRidingName(),
          displayAccessor: d => {
            const riding = d.provincialRiding()
            return riding ? <Link to={riding.URL()}>{riding.name}</Link> : ''
          },
          filterable: true
        },
        { id: 'federalRiding',
          name: 'Federal Riding',
          accessor: d => d.federalRidingName(),
          displayAccessor: d => {
            const riding = d.federalRiding()
            return riding ? <Link to={riding.URL()}>{riding.name}</Link> : ''
          },
          filterable: true
        }
      ])
    }

    const rowFilter = (r) => true

    const projects = this.props.powerProjects
      ? Object.values(this.props.powerProjects)
      : []

    return (
      <div id={this.props.id} className='PowerProjectTable margin-top'>
        <SortableTable
          columns={columns}
          baseSortColumnId={'name'}
          rows={projects}
          rowFilter={rowFilter}
        />
      </div>
    )
  }
}

export default PowerProjectTable



// WEBPACK FOOTER //
// ./src/components/Tables/PowerProjectTable.js